import { render, staticRenderFns } from "./MitoDiseaseConsentContainer.vue?vue&type=template&id=900e52e0"
import script from "./MitoDiseaseConsentContainer.vue?vue&type=script&lang=js"
export * from "./MitoDiseaseConsentContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports